const basicNameRegex = /^[a-zA-ZÀ-ÿ\s]+$/;

const nomeRazaoRegex = /^[a-zA-ZÀ-ÿ]+( [a-zA-ZÀ-ÿ]+)+( )*$/;

const removeNonDigits = /\D/g;

const allRepeatedNumbersRegex = /^(?!.*(\d)\1{7})\d+$/;

const logradouroRegex = /^(?=.*[a-zA-Z0-9À-ÿ.-])[a-zA-Z0-9À-ÿ\s.-]{3,}$/;

const bairroRegex = /^(?=.*[a-zA-Zà-úÀ-ÚçÇ\d.-])[a-zA-Z\sà-úÀ-ÚçÇ\d.-]+$/u;

export {
  basicNameRegex,
  nomeRazaoRegex,
  removeNonDigits,
  allRepeatedNumbersRegex,
  logradouroRegex,
  bairroRegex,
};
